import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export default class GetVisibilityProductsUseCase extends UseCase {
  constructor({repository, getCurrentUserService, getVisibilityProductsError}) {
    super()
    this._repository = repository
    this._getCurrentUserService = getCurrentUserService
    this._getVisibilityProductsError = getVisibilityProductsError
  }

  _throwGetVisibilityProductsError(message) {
    throw this._getVisibilityProductsError(`[HTTPVisibilityProductsRepository#get] ${message}`)
  }

  _getCurrentUser = async () => this._getCurrentUserService.execute()

  _getUserId = async () => {
    const currentUser = await this._getCurrentUser()
    return currentUser ? currentUser.getId() : this._throwGetVisibilityProductsError('Unknow user ID')
  }

  /**
   * @return {Promise<Object, Error>}
   */
  // ff_web_seller_make_available_visibility_products_pack
  execute = async ({adId, adPrice, visibilityPackVariant}) => {
    const userId = await this._getUserId()
    const visibilityProducts = await this._repository.getVisibilityProducts({
      adId,
      adPrice,
      userId,
      // ff_web_seller_make_available_visibility_products_pack
      visibilityPackVariant
    })
    return visibilityProducts.toJSON()
  }
}
